import { useTranslation } from 'react-i18next';
import { BottomSheet } from '@/shared/components/BottomSheet';
import { SKIN_SECTIONS } from '@/features/game/components/board/skins/metadata';
import { useSkinPicker } from '../hooks/useSkinPicker';
import { useUserSkins } from '../hooks/useUserSkins';
import { SkinSection } from './SkinSection';

interface SkinPickerSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenShop?: () => void;
}

export function SkinPickerSheet({ isOpen, onClose, onOpenShop }: SkinPickerSheetProps) {
  const { t } = useTranslation();
  const { selections, setComponentSkin, availableSkins, startTrial } = useSkinPicker();
  const { isOwned, isTrialed, isLoading } = useUserSkins();

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('skins.title')} className="!p-3">
      <div className="flex flex-col gap-4">
        {SKIN_SECTIONS.map((section) => (
          <SkinSection
            key={section.type}
            componentType={section.type}
            labelKey={section.labelKey}
            availableSkins={availableSkins}
            selectedSkinId={selections[section.type]}
            onSelect={setComponentSkin}
            onStartTrial={startTrial}
            onOpenShop={onOpenShop}
            isOwned={isOwned}
            isTrialed={isTrialed}
            isLoading={isLoading}
          />
        ))}
      </div>
    </BottomSheet>
  );
}
